export default "__VITE_ASSET__D3FG$TMy__"